import script from "./moneyComponentListing.vue?vue&type=script&setup=true&lang=js"
export * from "./moneyComponentListing.vue?vue&type=script&setup=true&lang=js"

import "./moneyComponentListing.vue?vue&type=style&index=0&id=2446b23e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2446b23e"]])

export default __exports__